module.exports = __webpack_public_path__ + "img/dox-lost.6d56895a.gif";